import { derived, writable, type Readable, get } from 'svelte/store';
import { getItem, setItem } from '../util/storage.js';
import { clientState } from '../util/stores.js';
import type { State } from '@pin/schemas/client-state-response';
import { loginSessionStore } from '../login/loginSessionStore.js';

const getSubmittedVotesKey = (pollId?: string, userSub?: string) => {
  return `${pollId}-${userSub}-submitted-votes`;
};

const localStorageKey = derived(
  [clientState as unknown as Readable<State>, loginSessionStore],
  ([$clientState, $loginSessionStore]) =>
    getSubmittedVotesKey($clientState.id, $loginSessionStore?.user?.sub)
);

const voteStore = () => {
  const { subscribe, set: setStore } = writable<string[] | undefined>(
    getItem('local', get(localStorageKey))
  );

  localStorageKey.subscribe((key) => {
    setStore(getItem('local', key));
  });

  const set = (value: string[]) => {
    setStore(value);
    setItem('local', get(localStorageKey), value);
  };

  return {
    subscribe,
    set,
  };
};

export default voteStore();
